import EnterpriseObjectMemberMetadata from "../../EnterpriseObjectMemberMetadata";
import EnterpriseObjectMetadata from "../../EnterpriseObjectMetadata";

class WorkGroupEnterpriseObjectMetadata extends EnterpriseObjectMetadata {

    constructor() {
        super();

        this.name = "WorkGroup";
        this.primaryEnterpriseComponent = "WorkGroup";

        let eom: EnterpriseObjectMemberMetadata = new EnterpriseObjectMemberMetadata();
        eom.name = "WorkGroup";
        eom.enterpriseComponent = "WorkGroup";
        eom.relationship = undefined;
        this.enterpriseComponentMembers.set(eom.name, eom);

        eom = new EnterpriseObjectMemberMetadata();
        eom.name = "WorkGroupAccountUser";
        eom.enterpriseComponent = "WorkGroupAccountUser";
        eom.relationship = "WorkGroupWorkGroupAccountUser";
        this.enterpriseComponentMembers.set(eom.name, eom);

        eom = new EnterpriseObjectMemberMetadata();
        eom.name = "WorkGroupOrganization";
        eom.enterpriseComponent = "WorkGroupOrganization";
        eom.relationship = "WorkGroupWorkGroupOrganization";
        this.enterpriseComponentMembers.set(eom.name, eom);

        eom = new EnterpriseObjectMemberMetadata();
        eom.name = "WorkGroupPosition";
        eom.enterpriseComponent = "WorkGroupPosition";
        eom.relationship = "WorkGroupWorkGroupPosition";
        this.enterpriseComponentMembers.set(eom.name, eom);

        eom = new EnterpriseObjectMemberMetadata();
        eom.name = "WorkGroupUserGroup";
        eom.enterpriseComponent = "WorkGroupUserGroup";
        eom.relationship = "WorkGroupWorkGroupUserGroup";
        this.enterpriseComponentMembers.set(eom.name, eom);
    }
}

export default WorkGroupEnterpriseObjectMetadata;